// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import { padding } from 'polished';

import { hover } from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';
import Responsive from '../responsive/Responsive';

type Props = {
  activeCategory: string,
  items: Array<Object>,
  onSelect: string => void
};

const List = styled.ul(({ activeIndex, listSize, theme }) => ({
  alignItems: 'center',
  borderBottomColor: theme.color.panel,
  borderBottomStyle: 'solid',
  borderBottomWidth: 1,
  display: 'flex',
  listStyle: 'none',
  margin: 0,
  ...padding('0', '0'),
  position: 'relative',
  width: '100%',
  '&::after': {
    backgroundColor: theme.color.primary,
    bottom: 0,
    content: '"\u00a0"',
    height: 2,
    left: 0,
    position: 'absolute',
    transform: `translateX(${activeIndex * 100}%)`,
    transition: 'transform 0.3s ease-in-out',
    width: `${100 / listSize}%`
  },
  [theme.mediaQuery.desktopAndUp]: {
    ...padding(5, '0'),
    width: listSize * 100
  }
}));

const Item = styled.li(
  ({ theme }) => ({
    color: theme.color.panelAccent,
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    fontSize: theme.fontSize.small,
    ...padding(15, '0'),
    transition: 'color 0.2s',
    textAlign: 'center',
    textTransform: 'uppercase',
    [theme.mediaQuery.desktopAndUp]: {
      ...padding(6, '0')
    }
  }),
  ({ active, theme }) =>
    active
      ? {
          color: theme.color.panelSelected
        }
      : hover({
          opacity: 0.8
        }),
  ({ highlight, theme }) =>
    highlight
      ? {
          color: theme.color.info
        }
      : {}
);

const ChallengesFilterCategories: React.FC<Props> = ({
  activeCategory,
  items,
  onSelect
}: Props) => (
  <Responsive mobile>
    {isMobile => (
      <List
        activeIndex={Math.max(items.findIndex(item => item.id === activeCategory), 0)}
        listSize={items.length}
      >
        {items.map(({ id, name, shortName }) => (
          <Tappable
            key={id}
            component={Item}
            active={id === activeCategory}
            listSize={items.length}
            onTap={() => onSelect(id)}
            stopPropagation
          >
            {isMobile ? shortName || name : name}
          </Tappable>
        ))}
      </List>
    )}
  </Responsive>
);

export default ChallengesFilterCategories;
